import { autoinject } from 'aurelia-framework';
import { EditBaseView } from 'General/Views/Dynamic/Edit/EditBaseView';

@autoinject
export class EditView extends EditBaseView { 
    
}